/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/prop-types */
import React from 'react';
import Modal from '@mui/material/Modal';
import { Typography, CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Unstable_Grid2';
import Button from '@mui/material/Button';
import { IoNotificationsOutline, IoCloseOutline, IoInformationCircleOutline } from 'react-icons/io5';
import axios from 'lib/axios';

const NoticeNotify = ({ isOpen, closeModal, notice }) => {
    function urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url) {
            return '<a target="_target" href="' + url + '">' + url + '</a>';
        });
    }

    async function handleResponse(type) {
        if (type === 'details') {
            await axios
                .post('/notice/viewed', { notice_id: notice.notice_id })
                .then(({ data }) => {
                    if (data.success) {
                        closeModal(true);
                        window.location.replace(`/news-events/news?activeTab=notice&notice_id=${notice.notice_id}`);
                    } else {
                        closeModal(true);
                    }
                })
                .catch((err) => console.log(err));
        } else if (type === 'close') {
            await axios
                .post('/notice/viewed', { notice_id: notice.notice_id })
                .then(({ data }) => {
                    if (data.success) {
                        closeModal(true);
                    } else {
                        closeModal(true);
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    return (
        <Modal
            keepMounted
            open={isOpen}
            onClose={closeModal}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(0, 0, 0, 0.4)'
            }}
        >
            <Box
                sx={{
                    width: { xs: '90vw', sm: '80vw', md: '500px' },
                    maxWidth: '500px',
                    outline: 'none'
                }}
            >
                <Card
                    sx={{
                        borderRadius: '20px',
                        border: 'none',
                        boxShadow: 'none',
                        backgroundColor: '#ffffff',
                        overflow: 'hidden',
                        position: 'relative'
                    }}
                >
                    {/* Close Button */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 16,
                            right: 16,
                            zIndex: 1
                        }}
                    >
                        <Button
                            onClick={() => handleResponse('close')}
                            sx={{
                                minWidth: 'auto',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                color: '#666',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                    transform: 'scale(1.05)'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <IoCloseOutline size={20} />
                        </Button>
                    </Box>

                    <CardContent sx={{ padding: '40px 32px' }}>
                        <Grid container spacing={3}>
                            {/* Icon */}
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Box
                                    sx={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        backgroundColor: 'rgba(30, 124, 136, 0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: 2
                                    }}
                                >
                                    <IoNotificationsOutline size={36} color="#1E7C88" />
                                </Box>
                            </Grid>

                            {/* Title */}
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 600,
                                        color: '#1a1a1a',
                                        textAlign: 'center',
                                        marginBottom: 1
                                    }}
                                >
                                    {notice.notice_title}
                                </Typography>
                            </Grid>

                            {/* Content */}
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography
                                    sx={{
                                        color: '#666',
                                        textAlign: 'center',
                                        lineHeight: 1.6,
                                        fontSize: '14px'
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: `${urlify(notice.plain_text_body).substring(0, 250)}${
                                            notice.plain_text_body.length > 250 ? '...' : ''
                                        }`
                                    }}
                                />
                            </Grid>

                            {/* Buttons */}
                            <Grid item xs={12} sx={{ marginTop: 3 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: 2,
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        alignItems: { xs: 'stretch', sm: 'center' }
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        onClick={() => handleResponse('close')}
                                        sx={{
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            padding: '8px 16px',
                                            borderColor: '#e0e0e0',
                                            color: '#666',
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none',
                                            minWidth: '100px'
                                        }}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleResponse('details')}
                                        startIcon={<IoInformationCircleOutline />}
                                        sx={{
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            padding: '8px 16px',
                                            backgroundColor: '#1E7C88',
                                            boxShadow: 'none',
                                            minWidth: '140px'
                                        }}
                                    >
                                        View Details
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Modal>
    );
};

export default NoticeNotify;
